import { render, staticRenderFns } from "./PromoNotice.vue?vue&type=template&id=4059adcd&scoped=true&"
import script from "./PromoNotice.vue?vue&type=script&lang=js&"
export * from "./PromoNotice.vue?vue&type=script&lang=js&"
import style0 from "./PromoNotice.vue?vue&type=style&index=0&id=4059adcd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4059adcd",
  null
  
)

export default component.exports